import React from 'react';

import TeamFilter from './TeamFilter';
import SeasonFilter from './SeasonFilter';
import GameFilter from './GameFilter';

function FootballGameFilterPane() {
  return (
    <React.Fragment>
      <TeamFilter />
      <SeasonFilter />
      <GameFilter />
    </React.Fragment>
  );
}

export default FootballGameFilterPane;
